import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Stack, Typography, Grid, Box } from '@mui/material';
import AccordionDetails from '@mui/material/AccordionDetails';
import Accordion from '@mui/material/Accordion';
import { endPoints } from 'api/endpoints';
import { useMutation } from 'react-query';
import axios from 'api/request';
// import { FaTrashAlt, FaEdit } from 'react-icons/fa';
import deleteIcon from 'assets/images/delete_icon.svg';
import editIcon from 'assets/images/edit_icon.svg';
import Btn from 'components/button';
import { cartStyle } from 'pages/cart/style';
import { deleteCartItemId, deleteModalPopup, deleteByApplication, toggleCostModals, catalogDetails } from 'pages/cart/store';
import { linuxVM, sqlPaaS, windowsVM, oelVM, oracleIaaS, sqlIaaS, oelOracle, storageBlog, aksNS, titleCase, alb } from 'utils';
import {
    keyvaultCatalogDefinitionId,
    kafkaCatalogDefinitionId,
    eventhubDefinitionId,
    pECatalogDefinitionId,
    NsgAutomationRulesProvisioningCatalogDefinitionID,
    linuxSLESCatalogDefinitionId,
    eipStackCatalogDefinitionId,
    adfCatalogDefinitionId,
    couchbaseDbDefinitionId,
    linuxOELCatalogDefinitionId,
    SlesPgtCatalogDefinitionId,
    SlesPgtDBCatalogDefinitionId,
    pgcsSqlIaaSCatalogDefinitionId,
    pgcsWindowsVmCatalogDefinitionId,
    AwsEC2CatalogDefinitionId,
    AwsRHELCatalogDefinitionId,
    AwsSLESCatalogDefinitionId,
    edapAksCatalogDefinitionId,
    AwsOracleRDSCatalogDefinitionId,
    AwsS3BucketCatalogDefinitionId,
    AwsOELCatalogDefinitionId,
    AwsSQLRDSCatalogDefinitionId,
    AwsPostgresqlCatalogDefinitionId,
    AwsDynamoDbCatalogDefinitionId,
    AwsEksnCatalogDefinitionId,
    AwsSQLIaasCatalogDefinitionId,
    AwsOracle19CCatalogDefinitionId,
} from 'utils/catalogDefinitionId';
import { getOrderSummary } from 'utils/OrderSummary/getOrderSummary';
import { commonStyles as style } from 'assets/style';
import { catalogs } from 'store';

const AppAccordion = ({ data, defaultExpanded }) => {
    const history = useHistory();
    const [cmpCatalogs] = useRecoilState(catalogs);
    const [, setIsDeleteModal] = useRecoilState(deleteModalPopup);
    const [, setDeleteCartItemId] = useRecoilState(deleteCartItemId);
    const [, setDeleteCartByApplication] = useRecoilState(deleteByApplication);
    const [expandAccordian, setExpandccordian] = React.useState(false);
    const [modal, setModal] = useRecoilState(toggleCostModals);
    const [, setCatalogDetails] = useRecoilState(catalogDetails);
    const cartItemApi = useMutation((cartItemId) => axios.get(`${endPoints.cart.getCartItem}/${cartItemId}`));

    const handleRedirection = ({ catalogServiceCode, cartItemId }) => {
        // Define a mapping of service types to their route patterns
        const routeMap = [
            {
                match: (code) => windowsVM.includes(code),
                path: (code) => `/vm-provisioning/Windows/WindowsServer/${code}/edit/${cartItemId}`,
            },
            {
                match: (code) => linuxVM.includes(code) && !oelVM.includes(code) && !linuxSLESCatalogDefinitionId.includes(code),
                path: (code) => `/vm-provisioning/Linux/RHEL/${code}/edit/${cartItemId}`,
            },
            {
                match: (code) => linuxOELCatalogDefinitionId.includes(code),
                path: (code) => `/vm-provisioning/Linux/OEL/${code}/edit/${cartItemId}`,
            },
            {
                match: (code) => [...linuxSLESCatalogDefinitionId, ...SlesPgtCatalogDefinitionId, ...SlesPgtDBCatalogDefinitionId].includes(code),
                path: (code) => `/vm-provisioning/Linux/SLES/${code}/edit/${cartItemId}`,
            },
            {
                match: (code) => sqlPaaS.includes(code),
                path: (code) => `/sql-paas-provisioning/${code}/edit/${cartItemId}`,
            },
            {
                match: (code) => oracleIaaS.includes(code) && !oelOracle.includes(code),
                path: (code) => `/oracle-provisioning/Linux/RHEL/${code}/edit/${cartItemId}`,
            },
            {
                match: (code) => oelOracle.includes(code),
                path: (code) => `/oracle-provisioning/Linux/OEL/${code}/edit/${cartItemId}`,
            },
            {
                match: (code) => sqlIaaS.includes(code),
                path: (code) => `/iaas-sql-provisioning/Windows/WindowsServer/${code}/edit/${cartItemId}`,
            },
            {
                match: (code) => pgcsSqlIaaSCatalogDefinitionId.includes(code),
                path: (code) => `/pgcs-iaas-sql-provisioning/Windows/WindowsServer/${code}/edit/${cartItemId}`,
            },
            {
                match: (code) => pgcsWindowsVmCatalogDefinitionId.includes(code),
                path: (code) => `/pgcs-vm-provisioning/Windows/WindowsServer/${code}/edit/${cartItemId}`,
            },
            {
                match: (code) => storageBlog.includes(code),
                path: (code) => `/azure-storage-provisioning/${code}/edit/${cartItemId}`,
            },
            {
                match: (code) => aksNS.includes(code),
                path: (code) => `/aks-nms-provisioning/${code}/edit/${cartItemId}`,
            },
            {
                match: (code) => edapAksCatalogDefinitionId.includes(code),
                path: (code) => `/edap-aks-nms-provisioning/${code}/edit/${cartItemId}`,
            },
            {
                match: (code) => keyvaultCatalogDefinitionId.includes(code),
                path: (code) => `/azure-key-vault/${code}/edit/${cartItemId}`,
            },
            {
                match: (code) => alb.includes(code),
                path: (code) => `/azure-load-balancer/${code}/edit/${cartItemId}`,
            },
            {
                match: (code) => kafkaCatalogDefinitionId.includes(code),
                path: (code) => `/kafka-topic-provisioning/${code}/edit/${cartItemId}`,
            },
            {
                match: (code) => eventhubDefinitionId.includes(code),
                path: (code) => `/event-hub-provisioning/${code}/edit/${cartItemId}`,
            },
            {
                match: (code) => pECatalogDefinitionId.includes(code),
                path: (code) => `/private-endpoint-provisioning/${code}/edit/${cartItemId}`,
            },
            {
                match: (code) => NsgAutomationRulesProvisioningCatalogDefinitionID.includes(code),
                path: (code) => `/application-nsgrules-automation/${code}/edit/${cartItemId}`,
            },
            {
                match: (code) => eipStackCatalogDefinitionId.includes(code),
                path: (code) => `/app-microservices-stack/${code}/edit/${cartItemId}`,
            },
            {
                match: (code) => adfCatalogDefinitionId.includes(code),
                path: (code) => `/azure-data-factory-provisioning/${code}/edit/${cartItemId}`,
            },
            {
                match: (code) => couchbaseDbDefinitionId.includes(code),
                path: (code) => `/couchbase-provisioning/${code}/edit/${cartItemId}`,
            },
            {
                match: (code) => AwsEC2CatalogDefinitionId.includes(code),
                path: (code) => `/aws-vm-provisioning/Windows/WindowsServer/${code}/edit/${cartItemId}`,
            },
            {
                match: (code) => AwsRHELCatalogDefinitionId.includes(code),
                path: (code) => `/aws-vm-provisioning/Linux-Rhel/${code}/edit/${cartItemId}`,
            },
            {
                match: (code) => AwsSLESCatalogDefinitionId.includes(code),
                path: (code) => `/aws-vm-provisioning/Linux/SLES/${code}/edit/${cartItemId}`,
            },
            {
                match: (code) => AwsOELCatalogDefinitionId.includes(code),
                path: (code) => `/aws-vm-provisioning/Linux-OEL/${code}/edit/${cartItemId}`,
            },
            {
                match: (code) => AwsOracleRDSCatalogDefinitionId.includes(code),
                path: (code) => `/aws-provisioning/oracle-rds/${code}/edit/${cartItemId}`,
            },
            {
                match: (code) => AwsS3BucketCatalogDefinitionId.includes(code),
                path: (code) => `/aws-s3-provisioning/${code}/edit/${cartItemId}`,
            },
            {
                match: (code) => AwsSQLRDSCatalogDefinitionId.includes(code),
                path: (code) => `/aws-provisioning/sql-rds/${code}/edit/${cartItemId}`,
            },
            {
                match: (code) => AwsPostgresqlCatalogDefinitionId.includes(code),
                path: (code) => `/aws-provisioning/postgresql-rds/${code}/edit/${cartItemId}`,
            },
            {
                match: (code) => AwsDynamoDbCatalogDefinitionId.includes(code),
                path: (code) => `/aws-provisioning/dynamodb-rds/${code}/edit/${cartItemId}`,
            },
            {
                match: (code) => AwsEksnCatalogDefinitionId.includes(code),
                path: (code) => `/aws-eks-nms-provisioning/${code}/edit/${cartItemId}`,
            },
            {
                match: (code) => AwsSQLIaasCatalogDefinitionId.includes(code),
                path: (code) => `/aws-iaas-sql-provisioning/Windows/WindowsServer/${code}/edit/${cartItemId}`,
            },
            {
                match: (code) => AwsOracle19CCatalogDefinitionId.includes(code),
                path: (code) => `/aws-oracle-provisioning/Linux/OEL/${code}/edit/${cartItemId}`,
            },
        ];

        // Find the first matching route and navigate to it
        const route = routeMap.find((routeConfig) => routeConfig.match(catalogServiceCode));
        if (route) {
            history.push(route.path(catalogServiceCode));
        } else {
            const catalog = cmpCatalogs.find((c) => c.catalogDefinitionId === catalogServiceCode);
            history.push(`${catalog?.cmpUri}/${catalogServiceCode}/edit/${cartItemId}`);
        }
    };
    React.useEffect(() => {
        if (cartItemApi?.isSuccess) {
            if (!eipStackCatalogDefinitionId?.includes(cartItemApi?.data?.data?.itemDetail?.catalogService?.catalogServiceCode)) {
                setCatalogDetails(
                    getOrderSummary({
                        orders: { ...cartItemApi?.data?.data?.itemDetail, catalogServices: [{ ...cartItemApi?.data?.data?.itemDetail?.catalogService }] },
                    })?.[0]
                );
            } else {
                setCatalogDetails({ stackCatalogs: cartItemApi?.data?.data?.itemDetail });
            }
            setModal({ ...modal, isCatalogDetails: { id: cartItemApi?.data?.data?.cartId, isDetailsOpen: true, isDetailsLoading: false } });
        }
    }, [cartItemApi?.isSuccess]);

    const handleDelete = async ({ cartItemId }) => {
        await setDeleteCartItemId(cartItemId);
        await setIsDeleteModal(true);
    };
    const handleAppdetailsModal = (cartid) => {
        setModal({ ...modal, isCatalogDetails: { id: cartid, isDetailsOpen: true, isDetailsLoading: true } });
        cartItemApi.mutate(cartid);
    };
    return (
        <>
            <Accordion defaultExpanded={defaultExpanded} disableGutters sx={cartStyle?.container?.accordion}>
                <AccordionSummary expandIcon={<ExpandMoreIcon sx={cartStyle.appAccordian.expandIcon} />} sx={cartStyle.appAccordian.containersummary}>
                    <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2} sx={cartStyle.appAccordian.stack}>
                        <Typography sx={cartStyle.appAccordian.application}>{titleCase(data?.application)}</Typography>

                        <Btn
                            // sx={cartStyle.appAccordian.remove}
                            sx={{ ...style.primaryMediumDangerButton, width: '120px' }}
                            onClick={(e) => {
                                e.stopPropagation();
                                setDeleteCartByApplication(data?.application);
                                setIsDeleteModal(true);
                            }}
                        >
                            Remove All
                        </Btn>
                    </Stack>
                </AccordionSummary>
                <AccordionDetails sx={cartStyle.appAccordian.containerAccDetails}>
                    <Accordion expanded>
                        <AccordionSummary sx={cartStyle.appAccordian.tableAccorSummary} className="detailssummary">
                            <Grid container sx={cartStyle.appAccordian.gridcontainer} spacing={1.5}>
                                <Grid item md={2.3} lg={2.8} sx={cartStyle.appAccordian.tableheader}>
                                    Catalog Type
                                </Grid>
                                <Grid item sx={cartStyle.appAccordian.tableheader} md={1.5} lg={1.8}>
                                    Environment
                                </Grid>
                                <Grid item md={0.5} lg={0.8} sx={cartStyle.appAccordian.tableheader}>
                                    Qty
                                </Grid>
                                <Grid item md={1.9} lg={1.9} sx={cartStyle.appAccordian.tableheader}>
                                    Recurring Cost
                                </Grid>
                                <Grid item md={1.8} lg={1.8} sx={cartStyle.appAccordian.tableheader}>
                                    One Time Cost
                                </Grid>
                                <Grid item md={1.5} lg={1.7} sx={cartStyle.appAccordian.tableheader}>
                                    Cost Center
                                </Grid>
                                <Grid item md={1.2} lg={1.2} sx={cartStyle.appAccordian.tableheader}>
                                    Actions
                                </Grid>
                            </Grid>
                        </AccordionSummary>
                        <AccordionDetails sx={{ padding: 0 }}>
                            {data?.items?.map((order, index) => (
                                <Accordion sx={{ padding: 0, boxShadow: 'inset 0 -2px #d7e5f8' }} expanded={expandAccordian} key={`accordion-${index}`}>
                                    <AccordionSummary
                                        sx={{ padding: 0 }}
                                        onClick={() => {
                                            setExpandccordian(false);
                                        }}
                                    >
                                        <Grid container sx={{ paddingLeft: { md: 1.5, lg: 3.5, xl: 3.6 } }} spacing={0.5}>
                                            <Grid
                                                item
                                                md={2.4}
                                                lg={2.8}
                                                xl={2.8}
                                                sx={cartStyle.appAccordian.catalogType}
                                                onClick={() => handleAppdetailsModal(order?.itemId)}
                                                data-testid={`details-modal-${order?.itemId}`}
                                            >
                                                {order.catalogType}
                                            </Grid>
                                            <Grid item sx={cartStyle.appAccordian.tableBodyVal} md={1.7} lg={1.7} xl={1.7}>
                                                {order.environment}
                                            </Grid>
                                            <Grid item md={0.8} lg={0.8} xl={0.9} sx={cartStyle.appAccordian.tableBodyVal}>
                                                {order.quantity}
                                            </Grid>
                                            <Grid item md={2} lg={1.9} xl={1.9} sx={cartStyle.appAccordian.tableBodyVal}>
                                                {`$${order.estimatedCosts?.totalRecurringCost?.estCost?.toFixed(2)}`}
                                            </Grid>
                                            <Grid item md={2.1} lg={1.8} xl={1.8} sx={cartStyle.appAccordian.tableBodyVal}>
                                                {`$${order.estimatedCosts?.totalOneTimeCost?.estCost?.toFixed(2)}`}
                                            </Grid>
                                            <Grid item md={1.5} lg={1.5} xl={1.5} sx={cartStyle.appAccordian.tableBodyVal}>
                                                {order.costCenter}
                                            </Grid>
                                            <Grid item md={1.5} lg={1.4} xl={1.3} sx={cartStyle.appAccordian.tableBodyVal}>
                                                <Stack direction="row" spacing={0.5} sx={cartStyle.appAccordian.actionsWrapper}>
                                                    <Box
                                                        sx={cartStyle.container.table.iconbtn}
                                                        onClick={() =>
                                                            handleRedirection({ catalogServiceCode: order?.catalogServiceCode, cartItemId: order?.itemId })
                                                        }
                                                        data-testid={`edit-${order?.itemId}`}
                                                    >
                                                        {/* <FaEdit style={cartStyle.container.table.editbtn} /> */}
                                                        <img style={cartStyle.container.table.editbtn} src={editIcon} alt="editIcon" />
                                                    </Box>
                                                    <Box
                                                        sx={cartStyle.container.table.deleteBtn}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleDelete({ cartItemId: order?.itemId });
                                                        }}
                                                        data-testid={`delete-${order?.itemId}`}
                                                    >
                                                        {/* <FaTrashAlt style={cartStyle.container.table.rejectBtn} /> */}
                                                        <img style={cartStyle.container.table.rejectBtn} src={deleteIcon} alt="deleteIcon" />
                                                    </Box>
                                                </Stack>
                                            </Grid>
                                        </Grid>
                                    </AccordionSummary>
                                </Accordion>
                            ))}
                        </AccordionDetails>
                    </Accordion>
                </AccordionDetails>
            </Accordion>
        </>
    );
};

AppAccordion.propTypes = {
    data: PropTypes.oneOfType([PropTypes.object]).isRequired,
    defaultExpanded: PropTypes.bool,
};

AppAccordion.defaultProps = {
    defaultExpanded: false,
};

export default React.memo(AppAccordion);
